import { getServerUrl } from '../utils/getServerUrl';
import { useQuery } from '@tanstack/react-query';
import { useQueryAccount } from './useQueryAccount';
import { useQueryAccountPlan } from '../..//universal-layout/hooks';
import { readCookie } from '@zapier/cookies';
async function fetchTopNavData({ currentAccountId, customUserId, isTrialing, allowTeams, planType, bffHostname, }) {
    var _a;
    const serverUrl = getServerUrl(bffHostname || '');
    const topnavUrl = new URL(`${serverUrl}/api/v3/navigation-data/topbar`);
    if (typeof isTrialing === 'boolean') {
        topnavUrl.searchParams.append('is-trialing', isTrialing.toString());
    }
    if (typeof allowTeams === 'boolean') {
        topnavUrl.searchParams.append('allow-teams', allowTeams.toString());
    }
    if (typeof planType === 'string') {
        topnavUrl.searchParams.append('plan-type', planType.toLowerCase());
    }
    const response = await fetch(topnavUrl.toString(), {
        credentials: 'include',
        headers: {
            'x-current-account-id': (currentAccountId === null || currentAccountId === void 0 ? void 0 : currentAccountId.toString()) || '',
            'x-customuser-id': (customUserId === null || customUserId === void 0 ? void 0 : customUserId.toString()) || '',
            'x-visitor-id': (_a = readCookie('visitor_id')) !== null && _a !== void 0 ? _a : '',
        },
    });
    if (!response.ok) {
        throw new Error('Response was not OK');
    }
    const topNavJSON = await response.json();
    return topNavJSON.data;
}
export const useQueryTopNav = ({ apiHostname, bffHostname, currentAccountId, customUserId, isInAppExperience, }) => {
    var _a, _b;
    const { data: accountData, isLoading: isLoadingAccountData, error: accountDataError, } = useQueryAccount({ apiHostname, currentAccountId });
    const { data: planData, isLoading: isLoadingPlanData, error: planDataError, } = useQueryAccountPlan(currentAccountId, (_a = accountData === null || accountData === void 0 ? void 0 : accountData.plan) === null || _a === void 0 ? void 0 : _a.id, apiHostname);
    const isTrialing = accountData === null || accountData === void 0 ? void 0 : accountData.isTrialing;
    const allowTeams = (_b = accountData === null || accountData === void 0 ? void 0 : accountData.plan) === null || _b === void 0 ? void 0 : _b.allowTeams;
    const planType = planData === null || planData === void 0 ? void 0 : planData.planType;
    const isEnabled = isInAppExperience
        ? !isLoadingAccountData &&
            !isLoadingPlanData &&
            !planDataError &&
            !accountDataError &&
            typeof currentAccountId === 'number' &&
            typeof customUserId === 'number'
        : true;
    return useQuery({
        queryKey: [
            'topnav',
            currentAccountId,
            customUserId,
            isTrialing,
            allowTeams,
            planType,
        ],
        queryFn: () => fetchTopNavData({
            currentAccountId,
            customUserId,
            isTrialing,
            allowTeams,
            planType,
            bffHostname,
        }),
        enabled: isEnabled,
        refetchOnWindowFocus: false,
        retry: false,
    });
};
//# sourceMappingURL=useQueryTopNav.js.map
// @zapier/universal-layout@12.0.37 (fb08e5a7f)
